import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaHandshake,
  FaGavel,
  FaLaptopCode,
  FaLeaf,
} from "react-icons/fa";

const PracticeAreas = () => {
  const practices = [
    {
      title: "Civil Matters",
      desc: "Expertise in property disputes, contracts, and ownership conflicts.",
      icon: <FaBuilding />,
      link: "/services/civil-cases",
    },
    {
      title: "Criminal Law",
      desc: "Strategic defense in bail trials, and white-collar crime litigation.",
      icon: <FaGavel />,
      link: "/services/criminal-cases",
    },
    {
      title: "Matrimonial",
      desc: "Compassionate legal support for divorce and custody matters.",
      icon: <FaUsers />,
      link: "/services/matrimonial-Cases",
    },
    {
      title: "Commercial",
      desc: "Comprehensive business advisory and high-stakes compliance.",
      icon: <FaHandshake />,
      link: "/services/commercial-disputes",
    },
    {
      title: "Cyber Law",
      desc: "Advanced protection against digital fraud and data theft.",
      icon: <FaLaptopCode />,
      link: "/services/cyber-cases",
    },
    {
      title: "Environmental",
      desc: "Navigating NGT litigation and environmental regulatory compliance.",
      icon: <FaLeaf />,
      link: "/services/environmental-matters",
    },
  ];

  return (
    <section className="relative py-24 px-6 lg:px-20 bg-[#0A0A0A] overflow-hidden">
      
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-10 right-10 text-[15vw] font-serif font-black text-white/5 select-none uppercase">
          Defense
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        
        {/* HEADER SECTION */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-[2px] w-10 bg-[#C8A27C]" />
              <span className="text-sm uppercase tracking-[0.4em] text-[#C8A27C] font-bold">
                Specializations
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl font-serif font-bold text-white leading-tight">
              Elite <span className="italic font-normal text-[#C8A27C]">Legal</span> <br /> 
              Practice Areas
            </h2>
          </div>
          <div className="hidden md:block">
            <Link 
               to="/services" 
               className="text-[#C8A27C] text-sm uppercase tracking-widest font-bold border-b border-[#C8A27C]/30 pb-2 hover:border-[#C8A27C] transition-all"
            >
              View All Services
            </Link>
          </div>
        </div>

        {/* BENTO GRID CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border border-white/10 rounded-3xl overflow-hidden bg-white/5 backdrop-blur-sm">

          {practices.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className="group relative p-10 border-white/5 border-[0.5px] hover:bg-[#C8A27C] transition-all duration-700 overflow-hidden"
            >
              {/* Subtle Card Number */}
              <span className="absolute top-6 right-8 text-4xl font-serif font-black text-white/5 group-hover:text-black/10 transition-colors">
                0{idx + 1}
              </span>

              {/* Icon Container */}
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl mb-8 text-2xl bg-white/5 text-[#C8A27C] group-hover:bg-black group-hover:text-[#C8A27C] transition-all duration-500 shadow-xl">
                {item.icon}
              </div>

              {/* Content */}
              <div className="relative z-10">
                <h3 className="text-2xl font-serif font-bold mb-4 text-white group-hover:text-black transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed mb-8 group-hover:text-black/80 transition-colors">
                  {item.desc}
                </p>
              </div>

              {/* Action */}
              <div className="flex items-center gap-2 text-[#C8A27C] text-xs uppercase tracking-widest font-bold group-hover:text-black transition-colors">
                <span>View Details</span>
                <span className="transform group-hover:translate-x-2 transition-transform">→</span>
              </div>

              {/* Decorative Corner Shadow */}
              <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-[#C8A27C]/10 rounded-full blur-3xl group-hover:bg-black/20 transition-all" />
            </Link>
          ))}

        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;